import { useState, useEffect } from 'react'
import TextBox from 'devextreme-react/text-box';
import SelectBox from 'devextreme-react/select-box';
import { useFavoriteProducts } from '../../../Providers/FavoriteProductsProvider';
import { useSavedBaskets } from '../../../Providers/SavedBasketsProvider';
import useAddProductsToSavedBasket from '../../../Components/BasketPage/Hooks/useAddProductsToSavedBasket';
import { useCart } from '../../../Providers/CartProvider';
import { toast } from 'react-toastify';
import LoadingSpinner from '../../../Components/Components/LoadingSpinner';
import Product from '../../Shop/Components/ProductComponents/Product';
import YesNoCancelMessageModal from '../../../Components/Components/Modals/YesNoCancelMessageModal';
import { useParams } from '../../../Providers/ParamsProvider';
import { useShop } from '../../../Providers/ShopProvider';

const FavoriteProductsTab = ({ pending, favoriteProducts, setRefreshFavoriteItemsTrigger, navigate, setIsLoadingBasket }) => {
    const { removeProductFromFavorite, selectedProducts, setSelectedProducts } = useFavoriteProducts()
    const { cartItems, addProductsToBasket } = useCart()
    const { setProducts } = useShop()
    const [showOrderSelectedModal, setShowOrderSelectedModal] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const { isMobile } = useParams()

    const handleSelectProduct = (index, qty) => {
        setSelectedProducts(prev => [...prev, { product: { index, qty } }])
    }

    const handleUnselectProduct = (index) => {
        const searchingIndex = selectedProducts.findIndex(item => item.product.index === index)
        if (searchingIndex !== -1) {
            setSelectedProducts(prev => prev.filter(item => item.product.index !== index))
        }
    }

    const handleRemoveClick = async (product) => {
        setIsLoading(true)
        const removeResult = await removeProductFromFavorite(product.index)
        if (removeResult) {
            setProducts((prevProducts) =>
                prevProducts.map((p) =>
                    p.index === product.index
                        ? { ...p, isFavorite: !p.isFavorite } : p))
            setRefreshFavoriteItemsTrigger(prev => !prev)
        }
        setIsLoading(false)
    }

    const handleOrderSelectedModalResponse = async (answer) => {
        if (answer == 'Cancel' || answer === null) {
            setShowOrderSelectedModal(false)
            return
        }
        setIsLoadingBasket(true)
        const formatedProducts = selectedProducts.map(item => ({
            index: item.product.index,
            qty: item.product.qty
        }));
        const res = await addProductsToBasket(formatedProducts, answer == 'Yes' ? true : false)
        setShowOrderSelectedModal(false)
        setIsLoadingBasket(false)
        if (!res) {
            toast.error('Błąd podczas dodawania produktów do koszyka')
            return
        }
        navigate('/Cart')
    }

    const handleAddToCartFromSavedBasket = async (product, quantity) => {
        const formatedProduct = [{
            index: product.index,
            qty: quantity && quantity != 0 ? quantity : 1,
        }]
        const res = await addProductsToBasket(formatedProduct, false)
        if (!res) {
            toast.error('Błąd podczas dodawania produktu do koszyka')
            return
        }
    }

    if (isLoading) {
        return <LoadingSpinner />
    }
    return (
        <>
            {favoriteProducts.length > 0 ? (
                <div className='favorite-products-responsive-padding-bottom'>
                    {favoriteProducts.map((p, key) => (
                        <Product
                            key={p.index}
                            product={p}
                            isBasketSummary={false}
                            additionalOptions={{ handleSelectProduct, handleUnselectProduct, handleRemoveClick, isCheckboxSelected: false }}
                            blockSetPriceFromBasket={true}
                            isSavedBasket={true}
                            handleAddToCartFromSavedBasket={handleAddToCartFromSavedBasket}
                        />
                    ))}
                </div>
            ) : (
                <div className='main-container-holder'>
                    <b className='ms-3' style={{ fontSize: '20px' }}>Brak obecnie obserowownych produktów</b>
                </div>
            )
            }
            {pending && <LoadingSpinner />}
            {/* DK : Dodatkowe opcje z których zrezygnowało TG */}
            {/* <BottomSection
                isMobile={isMobile}
                favoriteProducts={favoriteProducts}
                handleOrderSelectedModalResponse={handleOrderSelectedModalResponse}
                authState={authState}
                cartItems={cartItems}
                selectedProducts={selectedProducts}
                setShowOrderSelectedModal={setShowOrderSelectedModal}
            /> */}
            <YesNoCancelMessageModal
                show={showOrderSelectedModal}
                onHide={handleOrderSelectedModalResponse}
                title={'Pytanie'}
                message={'Twój koszyka zawiera już pozycje, co chcesz zrobić z zaznaczonymi pozycjami, które dodajesz do koszyka?'}
                yesText='Nadpisz koszyk'
                noText='Dopisz do koszyka'
            />
        </>
    )
}

const BottomSection = ({ isMobile, favoriteProducts, handleOrderSelectedModalResponse, authState, cartItems, selectedProducts, setShowOrderSelectedModal }) => {
    const { savedBaskets, handleGetSavedBasket, handleSaveBasket } = useSavedBaskets()
    const [showSaveBasketForm, setShowSaveBasketForm] = useState(false)
    const { handleAddProductsToSavedBasket } = useAddProductsToSavedBasket()
    const [showValidationError, setShowValidationError] = useState(false)
    const [selectedBasket, setSelectedBasket] = useState(null)
    const [basketName, setBasketName] = useState('')

    useEffect(() => {
        setBasketName('')
    }, [showSaveBasketForm])

    const nameColor = showValidationError ? '#fc1c41' : 'black'
    const savedBasketButtonsSectionStyle = favoriteProducts.length > 0 ? '' : 'hidden'

    const handleAddProductsToSavedBasketFunc = async () => {
        if (!selectedBasket) {
            toast.warning('Proszę wybrać szybkokoszyk')
            return
        }
        if (selectedProducts.length === 0) {
            toast.warning('Proszę wybrać produkty do dodania')
            return
        }
        await handleAddProductsToSavedBasket(selectedBasket.basketId, selectedProducts, true)
    }

    const handleSelectBasket = (e) => {
        setSelectedBasket(e)
    }

    const handleCreateSaveBasket = async () => {
        if (validData()) {
            if (await handleSaveBasket(selectedProducts, basketName)) {
                toast.success('Zapisano koszyk')
                handleGetSavedBasket()
            }
            setShowSaveBasketForm(false)
        }
    }

    const validData = () => {
        let result = true
        if (selectedProducts.length === 0) {
            toast.warning('Proszę wybrać produkty')
            result = false
        }
        if (basketName === null || basketName === undefined || basketName === '' || basketName.trim() === '') {
            setShowValidationError(true)
            result = false
        }
        return result
    }

    const handleOrderSelectedProducts = () => {
        if (selectedProducts.length === 0) {
            toast.warning('Proszę wybrać produkty')
            return
        }
        if (!authState.user) {
            toast.warning('Prosze się zalogować')
            return
        }
        if (!authState.custId) {
            toast.warning('Brak wybranego kontrahenta')
            return
        }
        if (cartItems.basketItems && cartItems.basketItems.length > 0) {
            setShowOrderSelectedModal(true)
        }
        else {
            handleOrderSelectedModalResponse('No')
        }
    }

    if (isMobile) {
        return (<div className="row saved-basket-favorite-items-tab-bottom-section" style={{ marginBottom: '45px' }}>
            <div className={`d-flex flex-column ${savedBasketButtonsSectionStyle}`}>
                <button className='btn-app-primary mb-2' onClick={() => { setShowSaveBasketForm(prev => !prev) }}>Utwórz nowy szybkokoszyk</button>
                <button className="btn-app-secondary mb-2" onClick={handleOrderSelectedProducts}> Zamów zaznaczone </button>
                <div className='favorite-products-add-to-existing-basket-holder d-none d-md-flex'>
                    <span className='mb-2'>Dodaj do istniejącego szybko koszyka</span>
                    <SelectBox
                        dataSource={savedBaskets}
                        placeholder="Wybierz koszyk"
                        displayExpr={'name'}
                        showClearButton={false}
                        className="cart-page-select-box"
                        noDataText='Brak zapisanych koszyków'
                        onValueChange={(e) => handleSelectBasket(e)}
                    />
                    <button className="btn-app-secondary mt-2" onClick={handleAddProductsToSavedBasketFunc}> Wybierz </button>
                </div>
            </div>
        </div>)
    }
    return (<div className="row saved-basket-favorite-items-tab-bottom-section">
        <div className={`d-flex align-items-center  ${savedBasketButtonsSectionStyle}`}>
            <div className="col-auto ms-3">
                <button className='btn-app-primary me-3' onClick={() => { setShowSaveBasketForm(prev => !prev) }}>Utwórz nowy szybkokoszyk</button>
            </div>
            <div className="col-auto ms-3 ms-md-0 mb-3 mt-3 mt-sm-0 mb-sm-0">
                <button className="btn-app-secondary" onClick={handleOrderSelectedProducts}> Zamów zaznaczone </button>
            </div>
            <div className="col"></div>
            <div className="col me-3">
                <div className="d-flex flex-column align-items-end mt-2 mt-md-0">
                    <span>Dodaj do istniejącego szybko koszyka</span>
                    <div className='d-flex align-items-center mt-1'>
                        <SelectBox
                            dataSource={savedBaskets}
                            placeholder="Wybierz koszyk"
                            displayExpr={'name'}
                            showClearButton={false}
                            className="cart-page-select-box"
                            noDataText='Brak zapisanych koszyków'
                            onValueChange={(e) => handleSelectBasket(e)}
                        />
                        <button className="btn-app-secondary ms-2" onClick={handleAddProductsToSavedBasketFunc}> Wybierz </button>
                    </div>
                </div>
            </div>
        </div>
        {showSaveBasketForm && (
            <div className='d-flex' style={{ marginTop: '-5px' }}>
                <TextBox
                    placeholder={'Nazwa koszyka'}
                    showClearButton={true}
                    width={'30%'}
                    value={basketName}
                    onValueChanged={(e) => setBasketName(e.value)}
                    style={{ borderColor: nameColor }}
                />
                <button type="button" className="btn btn-outline-success ms-2 me-2" onClick={() => handleCreateSaveBasket()}>Zapisz</button>
                <button type="button" className="btn btn-outline-danger" onClick={() => { setShowSaveBasketForm(false) }}>Anuluj</button>
            </div>
        )}
    </div>)
}

export default FavoriteProductsTab